import Button from "@/components/Button"
import { Modals, useModals } from "@/hooks/useModals"
import ActionsDropdown from "./ActionsDropdown"
import { Player } from "@/types/serializers"

const ActionBar = ({ player }: { player: Player }) => {
  const { openModal } = useModals()

  return (
    <div className="flex items-center gap-x-1.5">
      <ActionsDropdown player={player} />
      <Button
        size="sm"
        onClick={() => openModal(Modals.EditPlayer)}
        style="secondary"
      >
        Edit
      </Button>
      <Button size="sm" onClick={() => openModal(Modals.Share)}>
        Share
      </Button>
    </div>
  )
}

export default ActionBar
